import { toast } from "react-toastify";
import SidebarField from "../../../components/Sidebar/SidebarField";
import { FormField } from "../../../components/FormField";
import Button from "../../../components/Button";
import TextInput from "../../../components/TextInput";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import { IoMdAddCircleOutline, IoMdRemoveCircleOutline } from "react-icons/io";
import * as Yup from "yup";
import { InventoryApi } from "../../../apis/inventory.api";
import SelectDropdown from "../../../components/Dropdown/SelectDropdown";
import { useContext, useEffect, useState } from "react";
import { productApi } from "../../../apis/ProductListing.apis";
import LoaderContext from "../../../components/loader";
import masterApi from "../../../apis/master.api";
import Textarea from "../../../components/Textarea";
import { useSelector } from "react-redux";


const validationSchema = Yup.object().shape({
  dateofIssue: Yup.date()
    .required("Date of Issue is required")
    .typeError("Invalid date format"),
  issuedTo: Yup.string()
    .required("Issued To is required")
    .min(3, "Issued To must be at least 3 characters long"),
  // orderReference: Yup.string().required("Order Reference is required"),
  vendorLocation: Yup.string().required("Vendor Location is required"),
  isuedBy: Yup.string().required("Issued By is required"),
  attachments: Yup.array()
    .of(Yup.mixed().required("Each attachment must be valid"))
    .min(1, "At least one attachment is required"),
  itemDetails: Yup.array().of(
    Yup.object().shape({
      itemCode: Yup.string().required("Item Code is required"),
      itemDescription: Yup.string().required("Item Description is required"),
      quantity: Yup.number()
        .required("Quantity is required")
        .positive("Quantity must be positive")
        .integer("Quantity must be an integer"),
      unit: Yup.string().required("Unit is required"),
      // batchNumber: Yup.string().nullable(), // Optional field
      conditionOfGoods: Yup.string().nullable(), // Optional field
      unitCost: Yup.number()
        .required("Unit Cost is required")
        .positive("Unit Cost must be positive"),
      totalCost: Yup.number()
        .required("Total Cost is required")
        .positive("Total Cost must be positive"),
      comments: Yup.string().nullable(), // Optional field
    }),
  ),
});

function AddGIV({ open, handleClose, data, getAllData }) {
  const [allProducts, setAllProducts] = useState([]);
  const { handleLoading } = useContext(LoaderContext);
  const [isFullWidth, setIsFullWidth] = useState(false);
  const [unitMasterData, setUnitMasterData] = useState(false);
  const { currentUser } = useSelector((state) => state.store);

  console.log("currentUser:", currentUser);

  const formatDateForInput = (value) => {
    if (!value) {
      return "";
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return "";
    }

    return date.toISOString().split("T")[0];
  };

  const initialValues = {
    dateOfIssue: data?.dateOfIssue,
    issuedTo: data?.issuedTo || "",
    orderReference: data?.orderReference?._id || "",
    vendorLocation: data?.vendorLocation || "",
    attachments: data?.attachments || null,
    receivedBy: data?.receivedBy || currentUser?.first_name || "",  
    itemDetails: data?.itemDetails?.map((item) => ({
      itemCode: item.itemCode || "",
      itemDescription: item.itemDescription || "",
      quantity: item.quantity || "",
      unit: item.unit || "",
      // batchNumber: item.batchNumber || "",
      conditionOfGoods: item.conditionOfGoods || "",
      unitCost: item.unitCost || "",
      totalCost: item.totalCost || "",
      comments: item.comments || "",
    })) || [
      {
        itemCode: "",
        itemDescription: "",
        quantity: "",
        unit: "",
        // batchNumber: "",
        conditionOfGoods: "",
        unitCost: "",
        totalCost: "",
        comments: "",
      },
    ],
  };

  const getAllProducts = async () => {
    handleLoading(true);
    try {
      const res = await productApi.getAllProducts({
        filter: { status: "Approved" },
      });
      setAllProducts(res.data?.data?.products);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      handleLoading(false);
    }
  };
  const getAllUnitMaster = async () => {
    handleLoading(true);
    try {
      const res = await masterApi.getAllUnitMaster({});
      console.log("unit master", res);
      // setAllProducts(res.data?.data?.products);
      const data = res?.data?.data?.map((item) => ({
        name: item?.unit,
        _id: item?._id,
      }));

      console.log("data", data);
      setUnitMasterData(data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      handleLoading(false);
    }
  };

  console.log("getAllUnitMaster", unitMasterData);

  const handleSubmit = async (values, { resetForm }) => {
    console.log("Form Submitted", values);
    const payload = { ...values };

    // Order reference is optional and hidden in this form, so omit it when empty.
    if (!payload.orderReference) {
      delete payload.orderReference;
    }

    try {
      const res = data
        ? await InventoryApi.updateGIV(data?._id, payload)
        : await InventoryApi.createGIV(payload);
      console.log("Response:", res);
      getAllData();
      toast.success("GIV added successfully");

      resetForm();
    } catch (error) {
      console.error("Error while adding GIV:", error);
      toast.error("Failed to add GIV. Please try again.");
    }

    handleClose();
  };

  const handleFieter = (id) => {
    return allProducts?.find((p) => p?._id === id);
  };

  useEffect(() => {
    getAllProducts();
    getAllUnitMaster();
  }, []);

  if (open) {
    return (
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
        // validationSchema={validationSchema}
      >
        {({ values, handleChange, setFieldValue }) => (
          <Form>
            <SidebarField
              handleClose={handleClose}
              title={
                data
                  ? "Update Goods Issue Voucher (GIV)"
                  : "Add Goods Issue Voucher (GIV)"
              }
              button1={
                <Button text="Cancel" type="button" onClick={handleClose} />
              }
              button2={<Button text="Submit" type="submit" />}
              setHeaderWdith={setIsFullWidth}
            >
              <div className="w-full gap-4 flex flex-col bg-transparent py-2 px-2">
                <div
                  className={`grid  ${
                    isFullWidth ? "gap-6 grid-cols-2 p-6" : "grid-cols-1 gap-3"
                  }`}
                >
                  {data && (
                    <FormField label="Issue Number">
                      <TextInput
                        name="issueNumber"
                        value={data?.issueNumber || values.issueNumber}
                        onChange={handleChange}
                        disabled={"disabled"}
                      />
                      <ErrorMessage
                        name="issueNumber"
                        component="div"
                        className="error"
                      />
                    </FormField>
                  )}

                  <FormField label="Date of Issue">
                    <TextInput
                      name="dateOfIssue"
                      type="date"
                      value={formatDateForInput(
                        data?.dateOfIssue || values.dateOfIssue,
                      )}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="dateOfIssue"
                      component="div"
                      className="error"
                    />
                  </FormField>

                  <FormField label="Issued To">
                    <TextInput
                      name="issuedTo"
                      value={data?.issuedTo || values.issuedTo}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="issuedTo"
                      component="div"
                      className="error"
                    />
                  </FormField>

                  {/* <FormField label="Order Reference">
                    <TextInput
                      name="orderReference"
                      value={data?.orderReference._id || values.orderReference._id}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="orderReference"
                      component="div"
                      className="error"
                    />
                  </FormField> */}

                  <FormField label="Vendor Location">
                    <TextInput
                      name="vendorLocation"
                      value={data?.vendorLocation || values.vendorLocation}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="vendorLocation"
                      component="div"
                      className="error"
                    />
                  </FormField>

                  <FormField label="Received By">
                    <TextInput
                      name="receivedBy"
                      value={data?.receivedBy || values.receivedBy}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="receivedBy"
                      component="div"
                      className="error"
                    />
                  </FormField>

                  {/* Attachments */}
                  <FormField label="Attachments">
                    <TextInput
                      name="attachments"
                      type="file"
                      onChange={(e) => {
                        setFieldValue("attachments", e.target.files[0]);
                      }}
                    />
                    <ErrorMessage
                      name="attachments"
                      component="div"
                      className="error"
                    />
                  </FormField>
                </div>

                {/* Item Details Array */}
                <FieldArray name="itemDetails">
                  {({ push, remove }) => (
                    <div className="overflow-y-auto border rounded p-4">
                      <table className="w-full text-left border-collapse">
                        <thead>
                          <tr>
                            <th className="border-b p-2">Item</th>
                            <th className="border-b p-2">Item Code</th>
                            <th className="border-b p-2">Item Description</th>
                            <th className="border-b p-2">Quantity</th>
                            <th className="border-b p-2">Unit</th>
                            <th className="border-b p-2">Condition of Goods</th>
                            <th className="border-b p-2">Unit Cost</th>
                            <th className="border-b p-2">Total Cost</th>
                            <th className="border-b p-2">Comments</th>
                            <th className="border-b p-2">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {values.itemDetails.map((item, index) => (
                            <tr key={index} className="border-b">
                              <td className="p-2 font-semibold">
                                Item {index + 1}
                              </td>
                              <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.itemCode`}
                                  as={SelectDropdown}
                                  options={allProducts}
                                  optionLabel="name"
                                  optionValue="_id"
                                  placeholder="Select Item Code"
                                  className="w-24 border p-2"
                                  handleFilter={(name, v) => {
                                    setFieldValue(
                                      `itemDetails.${index}.itemCode`,
                                      v,
                                    );
                                    let item = handleFieter(v);
                                    item =
                                      item?.description?.replace(
                                        /<\/?[^>]+(>|$)/g,
                                        "",
                                      ) || "";
                                    setFieldValue(
                                      `itemDetails.${index}.itemDescription`,
                                      item,
                                    );
                                  }}
                                ></Field>
                                <ErrorMessage
                                  name={`itemDetails.${index}.itemCode`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td>
                              <td className="p-3">
                                <div className="relative">
                                  {values.itemDetails[index].itemDescription ? (
                                    <div
                                      className="border rounded text-ellipsis p-2 bg-gray-50 min-h-[60px] max-h-[120px] overflow-y-auto overflow-x-hidden text-sm"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          values.itemDetails[index]
                                            .itemDescription,
                                      }}
                                    />
                                  ) : (
                                    <Textarea
                                      name={`itemDetails.${index}.itemDescription`}
                                      value={
                                        values.itemDetails[index]
                                          .itemDescription
                                      }
                                      onChange={handleChange}
                                      placeholder="Item description will appear here when item is selected"
                                      className="w-full min-h-[60px] text-sm"
                                      disabled={true}
                                    />
                                  )}
                                </div>
                                <ErrorMessage
                                  name={`itemDetails.${index}.itemDescription`}
                                  component="div"
                                  className="error text-red-500 text-xs mt-1"
                                />
                              </td>
                              <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.quantity`}
                                  type="number"
                                  as={TextInput}
                                  className="w-full"
                                />
                                <ErrorMessage
                                  name={`itemDetails.${index}.quantity`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td>
                              <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.unit`}
                                  as={SelectDropdown}
                                  options={unitMasterData}
                                  optionLabel="unit"
                                  optionValue="_id"
                                  placeholder="Select unit"
                                  className="w-24 border p-2 "
                                  handleFilter={(name, v) => {
                                    setFieldValue(
                                      `itemDetails.${index}.unit`,
                                      v,
                                    );
                                  }}
                                />
                                <ErrorMessage
                                  name={`itemDetails.${index}.unit`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td>
                              {/* <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.batchNumber`}
                                  as={TextInput}
                                  className="w-full"
                                />
                                <ErrorMessage
                                  name={`itemDetails.${index}.batchNumber`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td> */}
                              <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.conditionOfGoods`}
                                  as={SelectDropdown}
                                  options={[
                                    { name: "1", _id: "1" },
                                    { name: "2", _id: "2" },
                                    { name: "3", _id: "3" },
                                    { name: "4", _id: "4" },
                                    { name: "5", _id: "5" },
                                  ]}
                                  optionLabel="name"
                                  optionValue="_id"
                                  placeholder="Select Grade"
                                  className="w-24 border p-2 "
                                  handleFilter={(name, v) => {
                                    setFieldValue(
                                      `itemDetails.${index}.conditionOfGoods`,
                                      v,
                                    );
                                  }}
                                ></Field>
                                <ErrorMessage
                                  name={`itemDetails.${index}.conditionOfGoods`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td>
                              <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.unitCost`}
                                  type="number"
                                  as={TextInput}
                                  className="w-full"
                                />
                                <ErrorMessage
                                  name={`itemDetails.${index}.unitCost`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td>
                              <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.totalCost`}
                                  type="number"
                                  as={TextInput}
                                  className="w-full"
                                />
                                <ErrorMessage
                                  name={`itemDetails.${index}.totalCost`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td>
                              <td className="p-2">
                                <Field
                                  name={`itemDetails.${index}.comments`}
                                  as={TextInput}
                                  className="w-full"
                                />
                                <ErrorMessage
                                  name={`itemDetails.${index}.comments`}
                                  component="div"
                                  className="error text-red500 text-sm"
                                />
                              </td>
                              <td className="p-2 flex justify-center items-center gap-2">
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    remove(index);
                                  }}
                                  type="button"
                                  className="text-red500 hover:text-red700"
                                >
                                  <IoMdRemoveCircleOutline
                                    style={{ fontSize: "1.5rem" }}
                                  />
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    push({
                                      itemCode: "",
                                      itemDescription: "",
                                      quantity: "",
                                      unit: "",
                                      // batchNumber: "",
                                      conditionOfGoods: "",
                                      unitCost: "",
                                      totalCost: "",
                                      comments: "",
                                    });
                                  }}
                                  type="button"
                                  className="text-green500 hover:text-green700"
                                >
                                  <IoMdAddCircleOutline
                                    style={{ fontSize: "1.5rem" }}
                                  />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </FieldArray>
              </div>
            </SidebarField>
          </Form>
        )}
      </Formik>
    );
  }
  return null;
}

export default AddGIV;
